import { normalizeAssetKeyQuery } from '@/features/assets/lib/assetKeyQuery';
import type { AssetCatalogFilters } from '@/features/assets/types/asset';
import type { DeliveryFilterOperator } from '@/features/delivery/types/contracts';

type AssetCatalogSearchParams = {
  q?: string;
  organizationId?: string;
  projectId?: string;
  minDurationMs?: number;
  maxDurationMs?: number;
  minSizeBytes?: number;
  maxSizeBytes?: number;
  rejected?: boolean;
  delivery?: string;
  deliveryOperator?: DeliveryFilterOperator;
  limit?: number;
  cursor?: string;
  sort?: NonNullable<AssetCatalogFilters['sort']>['field'];
  order?: NonNullable<AssetCatalogFilters['sort']>['direction'];
} & Partial<Record<`metadata.${string}`, string | boolean>>;

export function toAssetCatalogSearchParams(filters: AssetCatalogFilters): AssetCatalogSearchParams {
  const searchParams: AssetCatalogSearchParams = {
    q: normalizeAssetKeyQuery(filters.q) ?? undefined,
    organizationId: filters.organizationId || undefined,
    projectId: filters.projectId || undefined,
    minDurationMs: filters.minDurationMs,
    maxDurationMs: filters.maxDurationMs,
    minSizeBytes: filters.minSizeBytes,
    maxSizeBytes: filters.maxSizeBytes,
    rejected: filters.rejected,
    delivery: filters.delivery && filters.delivery !== 'all' ? filters.delivery : undefined,
    deliveryOperator:
      filters.delivery &&
      filters.delivery !== 'all' &&
      filters.delivery !== 'none' &&
      filters.deliveryOperator === 'not_in'
        ? 'not_in'
        : undefined,
    limit: filters.limit,
    cursor: filters.cursor || undefined,
    sort: filters.sort?.field,
    order: filters.sort?.direction,
  };

  for (const [key, value] of Object.entries(filters.metadata ?? {})) {
    const trimmedValue = value.trim();
    if (trimmedValue) searchParams[`metadata.${key}`] = trimmedValue;
  }

  for (const [key, present] of Object.entries(filters.metadataPresent ?? {})) {
    searchParams[`metadata.${key}.present`] = present;
  }

  return searchParams;
}
